/* Casa Livia · carrito lateral: flechas del carrusel y botón «Aggiungi» de «Ti piaceranno questi».
   Se escucha en document porque el carrito se vuelve a pintar entero en cada cambio. */
(function () {
  document.addEventListener('click', function (e) {
    var nav = e.target.closest('.cl-look__nav');
    if (nav) {
      var list = nav.parentElement.querySelector('.cl-look__list');
      if (list) list.scrollBy({ left: (nav.dataset.dir === 'prev' ? -1 : 1) * list.clientWidth, behavior: 'smooth' });
      return;
    }

    var btn = e.target.closest('.cl-look__add');
    if (!btn) return;
    e.preventDefault();
    var card = btn.closest('.cl-look__item');
    var field = card && card.querySelector('.cl-look__variante');
    if (!field || !field.value) return;

    var drawer = document.querySelector('cart-drawer');
    var sections = drawer && drawer.getSectionsToRender ? drawer.getSectionsToRender().map(function (s) { return s.id; }) : [];
    var testo = btn.textContent;
    btn.disabled = true;
    btn.textContent = '…';

    fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: Number(field.value), quantity: 1, sections: sections, sections_url: window.location.pathname })
    })
      .then(function (r) { return r.json(); })
      .then(function (state) {
        if (state.status) {
          btn.textContent = 'Esaurito';
          return;
        }
        if (drawer && drawer.renderContents) {
          drawer.renderContents(state);
        } else {
          window.location.href = (window.routes && window.routes.cart_url) || '/cart';
        }
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cl-look', productVariantId: state.variant_id, cartData: state });
        }
      })
      .catch(function () {
        btn.disabled = false;
        btn.textContent = testo;
      });
  });
})();
